import { RewriteFrames } from "@sentry/integrations";

// as per https://github.com/vercel/next.js/blob/canary/examples/with-sentry/utils/sentry.js
// For Node.js, rewrite Error.stack to use relative paths, so that source
// maps starting with ~/_next map to files in Error.stack with path
// app:///_next
const nextPublicSentryServerRootDir = "/var/task/";
const integration = new RewriteFrames({
  iteratee: (frame) => {
    frame.filename = frame.filename.replace(
      nextPublicSentryServerRootDir,
      "app:///"
    );
    frame.filename = frame.filename.replace(".next", "_next");
    return frame;
  },
});

export default integration;
